import { api } from "../api/Middleware";
import { TEMPLATES_URL } from "../api/Urls";

// Obter lista de templates
export const getTemplates = async (params = "", agentId = null) => {
  try {
    const queryParams = new URLSearchParams();
    
    if (agentId) {
      queryParams.append('agent_id', agentId);
    }
    
    if (params && params.startsWith('?')) {
      const existingParams = new URLSearchParams(params.substring(1));
      existingParams.forEach((value, key) => {
        queryParams.append(key, value);
      });
    } else if (params) {
      queryParams.append('search', params);
    }
    
    const queryString = queryParams.toString();
    const url = queryString ? `${TEMPLATES_URL}?${queryString}` : TEMPLATES_URL;
    
    const response = await api.get(url);
    return response.data;
  } catch (error) {
    console.error("Erro ao obter templates:", error);
    throw error;
  }
};

// Obter templates por tipo
export const getTemplatesByType = async (templateType = 'all') => {
  try {
    const params = templateType !== 'all' ? `?template_type=${templateType}` : '';
    const response = await api.get(`${TEMPLATES_URL}${params}`);
    return response.data;
  } catch (error) {
    console.error("Erro ao obter templates por tipo:", error);
    throw error;
  }
};

// Obter um template específico
export const getTemplate = async (id) => {
  try {
    const response = await api.get(`${TEMPLATES_URL}${id}/`);
    return response.data;
  } catch (error) {
    console.error(`Erro ao obter template ${id}:`, error);
    throw error;
  }
};

// Criar novo template
export const createTemplate = async (templateData) => {
  try {
    // Determina o tipo de conteúdo baseado no tipo de dados
    const isFormData = templateData instanceof FormData;
    const headers = isFormData ? 
      { "Content-Type": "multipart/form-data" } : 
      { "Content-Type": "application/json" };

    const response = await api.post(TEMPLATES_URL, templateData, { headers });
    return response.data;
  } catch (error) {
    console.error("Erro ao criar template:", error);
    throw error;
  }
};

// Atualizar template existente
export const updateTemplate = async (id, templateData) => {
  try {
    // Determina o tipo de conteúdo baseado no tipo de dados
    const isFormData = templateData instanceof FormData;
    const headers = isFormData ? 
      { "Content-Type": "multipart/form-data" } : 
      { "Content-Type": "application/json" };

    const response = await api.patch(`${TEMPLATES_URL}${id}/`, templateData, { headers });
    return response.data;
  } catch (error) {
    console.error(`Erro ao atualizar template ${id}:`, error);
    throw error;
  }
};

// Excluir template
export const deleteTemplate = async (id) => {
  try {
    const response = await api.delete(`${TEMPLATES_URL}${id}/`);
    return response.data;
  } catch (error) {
    console.error(`Erro ao excluir template ${id}:`, error);
    throw error;
  }
};

export const bulkDelete = async (payload, setNotify, setProgress, redirectUrl = "/templates") => {
  try {
    let response = await api.delete(TEMPLATES_URL + "bulk_delete/", {
      data: payload,
    });
    if (response.status === 200) {
      setNotify({
        title: "Sucesso!",
        message: "Operação realizada com sucesso!",
        type: "success",
        visible: true,
      });
      if (redirectUrl) {
        window.location.href = redirectUrl;
      }
      return true;
    }
  } catch (error) {
    console.log(error);
    //if(error.status !== 401) throw error.response;
    setNotify({
      title: "Oops!",
      message: error.response.data,
      type: "error",
      visible: true,
    });
  }
};

// Preview de template
export const previewTemplate = async (id) => {
  try {
    const response = await api.get(`${TEMPLATES_URL}${id}/preview/`);
    return response.data;
  } catch (error) {
    console.error(`Erro ao fazer preview do template ${id}:`, error);
    throw error;
  }
};

// Teste de email
export const testEmailTemplate = async (id, testEmail) => {
  try {
    const response = await api.post(`${TEMPLATES_URL}${id}/test_email/`, {
      test_email: testEmail
    });
    return response.data;
  } catch (error) {
    console.error(`Erro ao testar email do template ${id}:`, error);
    throw error;
  }
};

// Teste de webhook
export const testWebhookTemplate = async (id) => {
  try {
    const response = await api.post(`${TEMPLATES_URL}${id}/test_webhook/`);
    return response.data;
  } catch (error) {
    console.error(`Erro ao testar webhook do template ${id}:`, error);
    throw error;
  }
};

// Teste de template draft (rascunho)
export const testTemplateDraft = async (templateData) => {
  try {
    const response = await api.post(`${TEMPLATES_URL}test_template_draft/`, {
      template_data: {
        email_subject: templateData.email_subject,
        email_html_content: templateData.email_html_content,
        email_display_name: templateData.email_display_name,
        template_type: "email"
      },
      test_email: templateData.test_email
    }, {
      headers: { "Content-Type": "application/json" }
    });
    return response.data;
  } catch (error) {
    console.error("Erro ao testar template draft:", error);
    throw error;
  }
};

// Teste de geração IA
export const testAIGeneration = async (id, uid, phone, tempData = null) => {
  try {
    let response;
    
    if (id) {
      // Template salvo - usar endpoint normal
      response = await api.post(`${TEMPLATES_URL}${id}/test_ai_generation/`, {
        uid,
        phone
      });
    } else {
      // Template não salvo - usar endpoint de teste com dados temporários
      response = await api.post(`${TEMPLATES_URL}test_ai_generation_temp/`, {
        uid,
        phone,
        prompt: tempData.prompt,
        history_limit: tempData.history_limit,
        template_name: tempData.template_name
      });
    }
    
    return response.data;
  } catch (error) {
    console.error(`Erro ao testar geração IA${id ? ` do template ${id}` : ' com dados temporários'}:`, error);
    throw error;
  }
};

// Teste de análise follow-up
export const testFollowupAnalysis = async (id, uid, phone) => {
  try {
    const response = await api.post(`${TEMPLATES_URL}${id}/test_followup_analysis/`, {
      uid,
      phone
    });
    return response.data;
  } catch (error) {
    console.error(`Erro ao testar follow-up do template ${id}:`, error);
    throw error;
  }
};
